import TextInput from "components/Common/TextInput"
import React from "react"
import { Input, Label, Table } from "reactstrap"
import "./style.css"

export default function FormJackets({ form, handleChangeInput }) {
  /**
   * todo: di mapping dinamis dengan array
   */
  return (
    <div>
      <h3>ジャケット</h3>
      <Table>
        <thead>
          <tr>
            <th>トラウザーズ</th>
            <th>調整(cm)</th>
            <th></th>
            <th colSpan={2}>上がり（cm）</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ width: 150 }}>袖丈（右）</td>
            <td style={{ width: 150 }}>
              <TextInput
                value={form.sleeveRightAdjustment || ""}
                onChange={handleChangeInput}
                name="sleeveRightAdjustment"
              />
            </td>
            <td>
              <Input
                name={"sleeveRight"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.sleeveRight}
                defaultChecked={form.sleeveRight === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"sleeveRight"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.sleeveRight}
                defaultChecked={form.sleeveRight === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td style={{ width: 150 }}>
              <TextInput
                value={form.sleeveRightRise || ""}
                onChange={handleChangeInput}
                name="sleeveRightRise"
              />
            </td>
          </tr>
          <tr>
            <td>袖丈（左）</td>
            <td>
              <TextInput
                value={form.sleeveLeftAdjustment || ""}
                onChange={handleChangeInput}
                name="sleeveLeftAdjustment"
              />
            </td>

            <td>
              <Input
                name={"sleeveLeft"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.sleeveLeft}
                defaultChecked={form.sleeveLeft === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"sleeveLeft"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.sleeveLeft}
                defaultChecked={form.sleeveLeft === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.sleeveLeftRise || ""}
                onChange={handleChangeInput}
                name="sleeveLeftRise"
              />
            </td>
          </tr>
          <tr>
            <td>バスト</td>
            <td>
              <TextInput
                value={form.bustAdjustment || ""}
                onChange={handleChangeInput}
                name="bustAdjustment"
              />
            </td>

            <td>
              <Input
                name={"bust"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.bust}
                defaultChecked={form.bust === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"bust"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.bust}
                defaultChecked={form.bust === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.bustRise || ""}
                onChange={handleChangeInput}
                name="bustRise"
              />
            </td>
          </tr>
          <tr>
            <td>ウエスト</td>
            <td>
              <TextInput
                value={form.jacketWaistAdjustment || ""}
                onChange={handleChangeInput}
                name="jacketWaistAdjustment"
              />
            </td>

            <td>
              <Input
                name={"jacketWaist"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.jacketWaist}
                defaultChecked={form.jacketWaist === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"jacketWaist"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.jacketWaist}
                defaultChecked={form.jacketWaist === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.jacketWaistRise || ""}
                onChange={handleChangeInput}
                name="jacketWaistRise"
              />
            </td>
          </tr>
          <tr>
            <td>けまわし</td>
            <td>
              <TextInput
                value={form.kemawashiAdjustment || ""}
                onChange={handleChangeInput}
                name="kemawashiAdjustment"
              />
            </td>

            <td>
              <Input
                name={"kemawashi"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.kemawashi}
                defaultChecked={form.kemawashi === "シングル"}
              />
              <Label>シングル</Label>
              <Input
                name={"kemawashi"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.kemawashi}
                defaultChecked={form.kemawashi === "ダブル"}
              />
              <Label>ダブル</Label>
              <Input
                name={"kemawashi"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.kemawashi}
                defaultChecked={form.kemawashi === "タタキ"}
              />
              <Label>タタキ</Label>
            </td>
            <td style={{ width: 55 }}>幅</td>
            <td>
              {/* <Label>幅</Label> */}
              <TextInput
                value={form.kemawashiRise || ""}
                onChange={handleChangeInput}
                name="kemawashiRise"
              />
            </td>
          </tr>
          <tr>
            <td>膝幅</td>
            <td>
              <TextInput
                value={form.lengthAdjustment || ""}
                onChange={handleChangeInput}
                name="lengthAdjustment"
              />
            </td>

            <td>
              <Input
                name={"length"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.length}
                defaultChecked={form.length === "つめ"}
              />
              <Label>つめ</Label>
              <Input
                name={"length"}
                className="mx-4"
                type="radio"
                onChange={handleChangeInput}
                value={form.length}
                defaultChecked={form.length === "出し"}
              />
              <Label>出し</Label>
            </td>
            <td style={{ width: 55 }}></td>
            <td>
              <TextInput
                value={form.lengthRise || ""}
                onChange={handleChangeInput}
                name="lengthRise"
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}
